import React from 'react';

const pageStyle: React.CSSProperties = {
  maxWidth: 820,
  margin: '0 auto',
  padding: '32px 24px 64px',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  fontSize: 16,
  lineHeight: 1.55,
  color: '#1a1a1a',
};

const h1Style: React.CSSProperties = {
  fontSize: 28,
  fontWeight: 700,
  margin: '0 0 24px',
};

const h2Style: React.CSSProperties = {
  fontSize: 20,
  fontWeight: 700,
  margin: '32px 0 12px',
  textTransform: 'none',
};

const pStyle: React.CSSProperties = {
  margin: '0 0 12px',
  textAlign: 'justify',
};

const subPStyle: React.CSSProperties = {
  margin: '0 0 8px',
  paddingLeft: 24,
  textAlign: 'justify',
};

const Email = () => <a href="mailto:info@brands.kz">info@brands.kz</a>;

export const AgreementPage = () => (
  <main style={pageStyle}>
    <h1 style={h1Style}>Политика конфиденциальности</h1>

    <h2 style={h2Style}>Общие положения</h2>
    <p style={pStyle}>
      Мы стремимся защищать и уважать вашу частную жизнь. Эта Политика объясняет
      наш подход к персональным данным, которые мы получаем от вас или которые
      вы нам предоставляете. Если вы не согласны с этой Политикой, вам не
      следует использовать мобильное приложение Partner VPLUSE (далее – «Приложение»).
    </p>
    <p style={pStyle}>
      Настоящая Политика конфиденциальности (далее - Политика) составлена в
      соответствии с требованиями Закона Республики Казахстан от 21 мая 2013
      года № 94-V «О персональных данных и их защите» (далее - «Закон») и
      руководствуясь настоящей Политикой Товарищество с ограниченной
      ответственностью «RG Brands Kazakhstan» (далее «<strong>Оператор</strong>»)
      определяет порядок обработки персональных данных и меры по обеспечению
      безопасности персональных данных.
    </p>
    <p style={pStyle}>
      Передавая Оператору персональные и иные данные посредством Приложения,
      Пользователь подтверждает свое согласие на использование указанных данных
      на условиях, изложенных в настоящей Политике.
    </p>
    <p style={pStyle}>
      Безусловным акцептом настоящей Политики конфиденциальности является начало
      использования Приложения Пользователем.
    </p>
    <p style={pStyle}>
      Настоящая Политика Оператора в отношении обработки персональных данных
      применяется ко всей информации, которую Оператор может получить о
      пользователях Приложения.
    </p>

    <section>
      <h2 style={h2Style}>1. Основные понятия, используемые в Политике</h2>
      <p style={pStyle}>
        <strong>Приложение</strong> — мобильное приложение Partner VPLUSE,
        исключительные права на Приложение и его отдельные элементы (включая
        программное обеспечение, дизайн) принадлежат Оператору в полном объеме.
        Передача исключительных прав Пользователю не является предметом настоящей
        Политики конфиденциальности.
      </p>
      <p style={pStyle}>
        <strong>Оператор</strong> — владелец Приложения — Товарищество с
        ограниченной ответственностью «RG Brands Kazakhstan», самостоятельно или
        совместно с другими лицами организующие и (или) осуществляющие обработку
        персональных данных, а также определяющие цели обработки персональных
        данных, состав персональных данных, подлежащих обработке, действия
        (операции), совершаемые с персональными данными.
      </p>
      <p style={pStyle}>
        <strong>Обработка персональных данных</strong> — любое действие
        (операция) или совокупность действий (операций), совершаемых с
        использованием средств автоматизации или без использования таких средств
        с персональными данными, включая сбор, запись, систематизацию,
        накопление, хранение, уточнение (обновление, изменение), извлечение,
        использование, передачу (распространение, предоставление, доступ),
        обезличивание, блокирование, удаление, уничтожение персональных данных.
      </p>
      <p style={pStyle}>
        <strong>Персональные данные</strong> — персональные данные Пользователя,
        которые Пользователь предоставляет самостоятельно при регистрации или в
        процессе использования функционала Приложения.
      </p>
      <p style={pStyle}>
        <strong>Пользователь</strong> — лицо, использующее Приложение.
      </p>
      <p style={pStyle}>
        Применяемые в настоящей Политике термины и понятия, которые не оговорены
        в настоящем разделе, определяются в соответствии с действующим
        законодательством Республики Казахстан.
      </p>
    </section>

    <section>
      <h2 style={h2Style}>2. Условия и цели обработки персональных данных</h2>
      <p style={pStyle}>
        2.1. Политика конфиденциальности относится ко всем персональным данным,
        которые Пользователь предоставляет самостоятельно при регистрации или в
        процессе использования функционала Приложения.
      </p>
      <p style={pStyle}>
        <strong>2.2. Персональные данные могут использоваться в следующих целях:</strong>
      </p>
      <p style={subPStyle}>2.2.1. предоставления и поддерживания Приложения;</p>
      <p style={subPStyle}>2.2.2. уведомления об изменениях в Приложении;</p>
      <p style={subPStyle}>2.2.3. идентификации Пользователя;</p>
      <p style={subPStyle}>
        2.2.4. участия Пользователя в интерактивных функциях Приложения, в
        случае согласия Пользователя;
      </p>
      <p style={subPStyle}>
        2.2.5. направления Пользователю рекламных материалов, информации и
        запросов;
      </p>
      <p style={subPStyle}>2.2.6. проведение статистических и иных исследований.</p>

      <p style={pStyle}>
        <strong>2.3. Оператор в том числе обрабатывает следующие данные:</strong>
      </p>
      <p style={subPStyle}>2.3.1. фамилия, имя и отчество;</p>
      <p style={subPStyle}>2.3.2. адрес электронной почты;</p>
      <p style={subPStyle}>2.3.3. номер телефона (в т.ч. мобильного);</p>
      <p style={subPStyle}>2.3.4. дата рождения;</p>
      <p style={subPStyle}>2.3.5. пол;</p>
      <p style={subPStyle}>2.3.6. ИИН (Индивидуальный идентификационный номер);</p>
      <p style={subPStyle}>2.3.7. номера кредитной и дебетовой карт;</p>
      <p style={subPStyle}>
        2.3.8. информация, собираемая при помощи cookie-файлов, пиксельных тегов
        и иных технологий;
      </p>
      <p style={subPStyle}>2.3.9. данные об использовании Приложений;</p>
      <p style={subPStyle}>
        2.3.10. иные данные, предоставляемые пользователем при использовании
        Приложения.
      </p>

      <p style={pStyle}>
        2.4. Обезличенные данные Пользователей, собираемые с помощью сервисов
        интернет-статистики, служат для сбора информации о действиях
        Пользователей в Приложении, улучшения его качества и его содержания.
      </p>
      <p style={pStyle}>
        2.5. Срок хранения персональных данных определяется датой достижения
        целей их сбора и обработки, если иное не предусмотрено законодательством
        Республики Казахстан.
      </p>
      <p style={pStyle}>
        2.6. Пользователю запрещается указывать на Сайте персональные данные
        третьих лиц (за исключением условия представления интересов этих лиц,
        имея документальное подтверждение третьих лиц на осуществление таких
        действий).
      </p>
      <p style={pStyle}>
        2.7. Также Оператор имеет право направлять Пользователю уведомления о
        новых продуктах и услугах, специальных предложениях и различных
        событиях. Пользователь всегда может отказаться от получения
        информационных сообщений, направив Оператору письмо на адрес электронной
        почты <Email /> с пометкой «Отказ от уведомлений о результатах
        маркетинговых кампаний и о новых продуктах и услугах и специальных
        предложениях».
      </p>
      <p style={pStyle}>
        2.8. В некоторых случаях мы можем привлекать сторонние организации для
        обработки платежей в Приложении. При этом Персональные данные
        пользователя могут быть собраны данными организациями, а не нами, и на
        них будет распространяться политика конфиденциальности таких
        организаций, а не настоящая Политика конфиденциальности. Мы не имеем
        никакого контроля и не несем никакой ответственности в связи с
        использованием или раскрытием такими третьими лицами Персональных данных
        наших Пользователей.
      </p>
    </section>

    <section>
      <h2 style={h2Style}>3. Порядок обработки персональных данных</h2>
      <p style={pStyle}>
        3.1. Оператор обязуется использовать Персональные данные в соответствии
        с Законом Республики Казахстан «О персональных данных».
      </p>
      <p style={pStyle}>
        3.2. В отношении Персональных данных и иных данных Пользователя
        сохраняется их конфиденциальность, кроме случаев, когда указанные данные
        являются общедоступными.
      </p>
      <p style={pStyle}>
        3.3. Оператор имеет право сохранять архивную копию Персональных данных.
        Оператор имеет право хранить Персональные данные на серверах вне
        территории Республики Казахстан.
      </p>
      <p style={pStyle}>
        3.4. Оператор имеет право передавать Персональные данные без согласия
        Пользователя следующим лицам:
      </p>
      <p style={subPStyle}>
        3.4.1. государственным органам, в том числе органам дознания и
        следствия, и органам местного самоуправления по их мотивированному
        запросу;
      </p>
      <p style={subPStyle}>
        3.4.2. в иных случаях, прямо предусмотренных действующим
        законодательством Республики Казахстан.
      </p>
      <p style={pStyle}>
        3.5. Оператор имеет право передавать Персональные данные третьим лицам,
        не указанным в п. 3.4. настоящей Политики конфиденциальности, в следующих
        случаях:
      </p>
      <p style={subPStyle}>
        3.5.1. Пользователь выразил свое согласие на такие действия;
      </p>
      <p style={subPStyle}>
        3.5.2. передача необходима в рамках использования Пользователем
        Приложения или оказания услуг Пользователю.
      </p>
      <p style={pStyle}>
        3.6. В случае выявления неточностей в персональных данных, Пользователь
        может актуализировать их самостоятельно, путем направления Оператору
        уведомления на адрес электронной почты Оператора <Email /> с пометкой
        «Актуализация персональных данных».
      </p>
      <p style={pStyle}>
        3.7. Срок обработки Персональных данных является неограниченным.
        Пользователь может в любой момент отозвать свое согласие на обработку
        Персональных данных, направив Оператору уведомление посредством
        электронной почты на электронный адрес Оператора <Email /> с пометкой
        «Отзыв согласия на обработку персональных данных».
      </p>
    </section>

    <section>
      <h2 style={h2Style}>4. Защита персональных данных</h2>
      <p style={pStyle}>
        4.1. Оператор осуществляет надлежащую защиту Персональных и иных данных
        в соответствии с законодательством Республики Казахстан и принимает
        необходимые и достаточные организационные и технические меры для защиты
        Персональных данных.
      </p>
      <p style={pStyle}>
        4.2. Применяемые меры защиты в том числе позволяют защитить Персональные
        данные от неправомерного или случайного доступа, уничтожения, изменения,
        блокирования, копирования, распространения, а также от иных
        неправомерных действий с ними третьих лиц.
      </p>
      <p style={pStyle}>
        4.3. Оператор обеспечивает сохранность Персональных данных и принимает
        всевозможные меры, исключающие доступ к персональным данным
        неуполномоченных лиц.
      </p>
      <p style={pStyle}>
        4.4. Персональные данные пользователей не передаются каким-либо третьим
        лицам, за исключением случаев, прямо предусмотренных настоящей Политикой.
      </p>
    </section>

    <section>
      <h2 style={h2Style}>5. Правовые основания обработки персональных данных</h2>
      <p style={pStyle}>
        Оператор обрабатывает Персональные данные Пользователя только в случае
        их заполнения и/или отправки Пользователем самостоятельно через
        специальные формы, расположенные в Приложении.
      </p>
      <p style={pStyle}>
        Заполняя соответствующие формы и/или отправляя свои Персональные данные
        Оператору, Пользователь выражает свое согласие с данной Политикой.
      </p>
      <p style={pStyle}>
        Оператор обрабатывает обезличенные данные о Пользователе в случае, если
        это разрешено в настройках мобильного телефона Пользователя.
      </p>
    </section>

    <section>
      <h2 style={h2Style}>6. Трансграничная передача персональных данных</h2>
      <p style={pStyle}>
        Оператор до начала осуществления трансграничной передачи персональных
        данных обязан убедиться в том, что иностранным государством, на
        территорию которого предполагается осуществлять передачу персональных
        данных, обеспечивается надежная защита прав субъектов персональных
        данных.
      </p>
      <p style={pStyle}>
        Трансграничная передача персональных данных на территории иностранных
        государств, не отвечающих вышеуказанным требованиям, может
        осуществляться только в случае наличия согласия в письменной форме
        субъекта персональных данных на трансграничную передачу его
        персональных данных и/или исполнения договора, стороной которого
        является субъект персональных данных.
      </p>
    </section>

    <section>
      <h2 style={h2Style}>7. Заключительные положения</h2>
      <p style={pStyle}>
        Пользователь может получить любые разъяснения по интересующим вопросам,
        касающимся обработки его персональных данных, обратившись к Оператору с
        помощью электронной почты на адрес <Email />.
      </p>
      <p style={pStyle}>
        Мы можем время от времени обновлять нашу Политику. Мы уведомим вас о
        любых изменениях, разместив новую Политику конфиденциальности на этой
        странице. При этом использование Пользователем Приложения после
        вступления в силу таких изменений означает принятие ими новой редакции
        Политики конфиденциальности.
      </p>
      <p style={pStyle}>
        Рекомендуется периодически просматривать эту Политику на предмет
        изменений. Изменения в этой Политике вступают в силу, когда они
        публикуются на этой странице.
      </p>
      <p style={pStyle}>
        В случае возникновения любых споров или разногласий, связанных с
        исполнением настоящей Политики, Пользователь и Оператор приложат все
        усилия для их разрешения путем проведения переговоров между ними. В
        случае, если споры не будут разрешены путем переговоров, споры подлежат
        разрешению в суде общей юрисдикции по месту нахождения Оператора в
        установленном действующим законодательством Республики Казахстан.
      </p>
      <p style={pStyle}>
        Настоящая Политика вступает в силу для Пользователя с момента
        регистрации его в Приложении на мобильном устройстве Пользователя.
      </p>
      <p style={pStyle}>
        Настоящая Политика составлена на русском языке, являющимся понятным для
        Пользователя и Оператора.
      </p>
      <p style={pStyle}>Политика действует бессрочно до замены ее новой версией.</p>
    </section>
  </main>
);
